import React, { useEffect, useState } from 'react'
import "./style.css"

import { Title } from '../../Components/Atoms';
import { Button } from '@chakra-ui/react';
import { AddIcon } from '../../Assets/images/svgs';
import { useNavigate } from 'react-router-dom';
import { getClients } from '../../APIs';
import Loader from '../Loader';

const ViewClients = () => {
  const navigate = useNavigate();

  const [ clients, setClients ] = useState([]);
  const [ showLoading, setShowLoading ] = useState(true);

  const fetchClients = async () => {
    let clients = await getClients();
    if (clients && clients.length) {
      setClients(clients);
    }

    setShowLoading(false);
  }

  useEffect(() => {
    fetchClients();
  }, [])

  return (
    <>
      {!showLoading ?
        <div className='view-clients'>
          <Button onClick={() => navigate("/lease/addclient") } className="add-new-client">
            <AddIcon />
            Add New Client
          </Button>
          <div className="client-cards-wrapper">
          { clients.map(client => (
              <div className="client-card-wrapper">
                <Title>{ client.cName }</Title>
                <div className="client-details-wrapper">
                  <div className="client-details-left">
                    <label>
                      Email
                      <p>{ client.eml }</p>
                    </label>
                    <label>
                      No. of vehicles leased
                      <p>{ client.leasedVehCnt }</p>
                    </label>
                    <label>
                      Address
                      <p>{ client.add }</p>
                    </label>
                    <label>
                      Contact Number
                      <p>{ client.dmMob }</p>
                    </label>
                  </div>
                  <div className="client-details-right">
                  <label>
                      GST Number
                      <p>{ client.gstNum }</p>
                    </label>
                    <label>
                      Amount per vehicle
                      <p>{ client.amtPrVeh }</p>
                    </label>
                    <label>
                      Pincode
                      <p>{ client.pincode }</p>
                    </label>
                    <label>
                      Decision Maker
                      <p>{ client.dmNm }</p>
                    </label>
                  </div>
                </div>
              </div>
            )) }
          </div>
        </div>
      : <Loader hide={true} />}
    </>
  )
}

export default ViewClients
